(function() {

  /***** LANGUAGE REDIRECTION *****/
  function redirectIfRequired(desiredLocale, currentLanguage) {

    var inFifteenMinutes = new Date(new Date().getTime() + 15 * 60 * 1000);
    Cookies.set('language_redirected', '1', {
        path: '/',
        expires: inFifteenMinutes
    });

    if (desiredLocale.locale === currentLanguage) {
      return;
    }

    // Parse the current URL
    var currentURL = new URL(window.location.href);

    // Extract the query parameters from the current URL
    var queryParams = currentURL.search;

    var languageNeutralRoute = new URL(document.querySelector("link[hreflang='x-default']").href).pathname;

    // Construct the new URL for redirection while preserving parameters
    var newURL = (!!desiredLocale.primary ? '' : '/' + desiredLocale.locale) + languageNeutralRoute + queryParams;

    // Update the window location with the new URL
    window.location.href = newURL;
  }

  function getDesiredLocale(browserLanguages, locales) {
    for (var i = 0, length = browserLanguages.length; i < length; ++i) {
      var browserLanguage = browserLanguages[i];

      if (browserLanguage === 'de-DE') {
        browserLanguage = 'de';
      } else if (browserLanguage.startsWith('fr-')) {
        browserLanguage = 'fr';
      }

      var desiredLocale = locales.find(l => l.shop_locale.locale === browserLanguage);

      if (!!desiredLocale) {
        return desiredLocale.shop_locale;
      }
    }    
    
    return locales.find(l => !!l.shop_locale.primary).shop_locale;
  }

  function redirectLanguage() {
      var isPreviewMode = !!document.querySelector('#preview-bar-iframe');
      var isEditMode = isInIframe();

      if (isPreviewMode || isEditMode || Shopify.designMode || Shopify.inspectMode || Shopify.visualPreviewMode || !!Cookies.get('language_redirected')) {
        return;
      }
      
      if (window.location.hostname === '127.0.0.1') {
        return;
      } 
      
      var desiredLocale = getDesiredLocale(navigator.languages, available_locales || []);
      
      // Check if the user agent includes 'Instagram'
      var userAgent = navigator.userAgent;
      if (userAgent.includes('Instagram')) {
        // Find the language code within the User-Agent string
        var languageMatch = userAgent.match(/(\w{2}_\w{2})/);

        if (languageMatch) {
          var languageCode = languageMatch[0];

          if (languageCode.includes('de')) {
            desiredLocale = {
              "locale": "de",
              "enabled": true,
              "primary": false,
              "published": true
            };
          } else if (languageCode.includes('fr')) {
            desiredLocale = {
              "locale": "fr",
              "enabled": true,
              "primary": false,
              "published": true
            };
          }

          redirectIfRequired(desiredLocale, Shopify.locale);
          return;
        }
      }

      redirectIfRequired(desiredLocale, Shopify.locale);
  }

  function isInIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
        return true;
    }
  }

  /***** MOBILE NAV *****/
  function MobileNav(domElement) {
    this.nav = domElement;
    this.trigger = domElement.querySelector('[data-mobile-nav-trigger]');
    this.content = domElement.querySelector('[data-mobile-nav-content]');
    this.closeButton = domElement.querySelector('[data-mobile-nav-close]');
    this.isOpen = false;
    this.hasStickyClass = null;
    this.initEvents(this);
    this.applyStickyClass();
  }

  MobileNav.prototype.initEvents = function(self) {
    this.trigger.addEventListener('click', function() {
      self.toggle();
    });

    this.closeButton.addEventListener('click', function() {
      self.close();
    });

    document.body.addEventListener('click', function(e) {
      if (!self.isInMobileNav(e.target)) {
        self.close();
      }
    });

    window.addEventListener('scroll', function() {
      self.applyStickyClass();
    });
  };

  MobileNav.prototype.toggle = function() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  };

  MobileNav.prototype.open = function() {
    if (this.isOpen) {
      return;
    }

    this.nav.classList.add('active');
    this.isOpen = true;
  };

  MobileNav.prototype.close = function() {
    if (!this.isOpen) {
      return;
    }

    this.nav.classList.remove('active');
    this.isOpen = false;
  };

  MobileNav.prototype.isInMobileNav = function(domElement) {
      while (!!domElement) {
        if (domElement === this.nav) {
          return true;
        }

        domElement = domElement.parentElement;
      }
      
      return false;
  };

  MobileNav.prototype.applyStickyClass = function() {
    var requiredOffset = 90;
    var currentScroll = document.scrollingElement.scrollTop;

    if (currentScroll > requiredOffset && this.hasStickyClass !== true) {
      this.hasStickyClass = true;
      this.nav.classList.add('sticky');
      return;
    } 
    
    if (currentScroll <= requiredOffset && this.hasStickyClass !== false) {
      this.hasStickyClass = false;
      this.nav.classList.remove('sticky');
    } 
  };

  function toggleClass(element, cssClass) {
    if (element.classList.contains(cssClass)) {
      element.classList.remove(cssClass);        
    } else {
      element.classList.add(cssClass);
    }
  }

  /***** INITIALIZATION *****/
  function initByQuerySelector(querySelector, classRef) {
    var domElements = document.querySelectorAll(querySelector);

    for (var i = 0, length = domElements.length; i < length; ++i) {
      new classRef(domElements.item(i));
    }
  }

  function DOMready(callback) {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
  }

  redirectLanguage();
 

  document.addEventListener('DOMContentLoaded', function() {
    returnPrimeScript();
  });

  DOMready(function(){
    initByQuerySelector('[data-mobile-nav]', MobileNav);
  
    var mobileNavUser = document.querySelector('.site-nav-user--mobile');
    if (mobileNavUser) {
        mobileNavUser.addEventListener('click', function(e) {
            toggleClass(e.currentTarget, 'active');
        });
    }

      // Add return button start
      // const chElementObserver = new MutationObserver((mutations, obs) => {
      //
      //
      //   if (window.location.pathname.includes('/account/orders/')) {
      //     var returnLink = document.createElement('div');
      //     if (shopify_order_status == 'fulfilled'){
      //       var html = '<button class="js-return-exchange customerHub chButton">'
      //       html += theme.strings.returnButton;
      //       html += '</button>';
      //     returnLink.innerHTML = html;
      //     } else {
      //       var html = '<button class="js-return-exchange disabled customerHub chButton">';
      //       html += theme.strings.returnNotAvailable;
      //       html += '</button>';
      //       returnLink.innerHTML = html;
      //     }
      //     document.querySelector('.chContent-BPCW-Order--Details-OtherActions').prepend(returnLink);
      //
      //     obs.disconnect();
      //   }
      // });
      //
      // chElementObserver.observe(document, {
      //   childList: true,
      //   subtree: true
      // });
      // add return button end
  });
})();

/***** USP ELEMENT *****/
if (!(window.location.pathname.includes("frontpage") || window.location.pathname.includes("floyd-wheel-sets") || window.location.pathname.includes("floyd-travel-cases"))){ //collection name
  var usp_element = document.getElementById("shopify-section-text-columns");
  if (usp_element){
    usp_element.style.display = "none";
  }
}

function returnPrimeScript(){
    let order_numbers = []
    var ReturnElements = document.querySelectorAll('.return__exchange');
    Array.prototype.forEach.call(ReturnElements, function(el, i) {
        order_numbers.push(el.getAttribute('data-order_name'));
    });

    let url = 'https://admin.returnprime.com/get-fulfilled-order-status';
    let data = {
        order_numbers: order_numbers,
        store_name: Shopify.shop
    }
    fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        })
        .then(response => response.json())
        .then(data => {
            let orders = data.orders;
            Array.prototype.forEach.call(ReturnElements, function(el, i) {
                let orderId = el.getAttribute('data-order_name');
                orders.forEach(function(order) {
                    if (order.order_id === orderId && !order.status) {
                        el.querySelector(".js-return-exchange").classList.add("disabled");
                        el.querySelector(".js-return-exchange").innerHTML = "Not avalible";
                    }

                })
            })
        })
        .catch((error) => {
        });



    // on click of return button redirect to returnprime 

    [...document.querySelectorAll(".js-return-exchange")].forEach(el => el.addEventListener('click', function(e) {
        let OrderId = el.getAttribute('data-order') || shopify_order_number;
        let CustomerEmail = el.getAttribute('data-customer') || shopify_customer_email;
        let ReturnUrl = 'https://admin.returnprime.com/fetch_order';

        let data = {
            order_number: OrderId,
            email: CustomerEmail,
            store: Shopify.shop,
           //locale:Shopify.locale //Use it only for multi-lang stores

        }

        el.classList.add("rp_btn_loading");
        fetch(ReturnUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            })
            .then(response => response.json())
            .then(response => {
              el.classList.remove("rp_btn_loading");
                if (response.success == false) {
                    var ErrorMessage = response.message;
                    alert(ErrorMessage);

                } else if (response.success == true) {

                   window.location.href = response.url;

                }
          
          

            })
            .catch((error) => {
                el.classList.remove("rp_btn_loading");                    
              var ErrorMessage = error.message;
                alert(ErrorMessage);
            });
    }))


}

/***** PRODUCT SORT *****/

/* When the user clicks on the button, 
toggle between hiding and showing the dropdown content */
function toggleSortByOptions() {
  document.getElementById("sort-by--options")?.classList.toggle("show");
}

// Close the dropdown menu if the user clicks outside of it
window.onclick = function(event) {
  if (!(event.target.matches('.sort-by--dropdown') || event.target.matches('.sort-by--button') || event.target.matches('.arrow-down')) && document.getElementById("sort-by--options")?.classList.contains('show') ) {
    document.getElementById("sort-by--options")?.classList.toggle("show");
  }
}

/***** COLOR VARIANT *****/
function openColorVariant(colorUrl) {
window.location.href = colorUrl;
}

/***** CUSTOM INSTANT BUY ON PRODUCT PAGE *****/
function redirectToCheckout(){
const url = window.location.href;
const urlParams = new URLSearchParams(new URL(url).search);
const variantId = urlParams.get('variant');
const checkoutURL = window.location.origin + window.Shopify.routes.root + "cart/" + variantId + ":1";

window.location.href = checkoutURL;

}

/***** ATC *****/

function addToCart(productIds, propertyProductId, propertyName, propertyContent) {
// Ensure productIds is an array
if (!Array.isArray(productIds)) {
    productIds = [productIds];
}

// Construct the items array for the request body
const items = productIds.map(productId => {
    const item = {
        id: productId,
        quantity: 1
    };
    if (productId === propertyProductId && propertyContent) {
        item.properties = {
            [propertyName]: propertyContent
        };
    }
    return item;
});

// Construct the request body
 const requestBody = {
    items: items
}; 

// Send the request
fetch('/cart/add.js', {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
    },
    body: JSON.stringify(requestBody)
})
.then(response => response.json())
.then(data => {
    //window.location.href = window.location.origin + window.Shopify.routes.root + "cart/";
    //document.dispatchEvent(new CustomEvent('cart:updated', {  }));
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {}));
})
.catch(error => {
    console.error('Error adding products to cart:', error);
});
}

function secondaryAddToCart(){
const url = window.location.href;
const urlParams = new URLSearchParams(new URL(url).search);
const variantId = urlParams.get('variant');
addToCart(variantId);
}

function getWheelsVariantID(colorInitials) {
const variantIDs = {
    KO: "51771682718045",
    LG: "51771682849117",
    SY: "51771682881885",
    GP: "51771682914653",
    Glow: "51771682947421",
    RGold: "51771683144029",
    RGreen: "51771683438941",
    NP: "51771683340637",
    MP: "51771683373405",
    FP: "51771683406173",
    JB: "51771683733853",
    KB: "51771683766621",
    FR: "51771683799389"
};

return variantIDs[colorInitials] || null;
}

function getWheelsColorName(colorInitials) {
const colorNames = {
  KO: "Kickin Orange",
  LG: "Laser Green",
  SY: "Speed Yellow",
  GP: "Glitter Party",
  Glow: "Glow in the Dark",
  RGold: "Rocket Gold",
  RGreen: "Racing Green",
  NP: "Neon Pink",
  MP: "Marshmallow Pink",
  FP: "Floyd Pink",
  JB: "Jet Blue",
  KB: "Knievel Blue",
  FR: "Floyd Red"
};

return colorNames[colorInitials] || null;
}

function addWheelsAndCaseToCart(){
const url = window.location.href;

const urlParams = new URLSearchParams(new URL(url).search);
const caseVariantID = urlParams.get('variant');
const wheelsColorInitials = urlParams.get('wheels-color-initials');

    const wheelsVariantID = getWheelsVariantID(wheelsColorInitials);
    const wheelsColorName = getWheelsColorName(wheelsColorInitials);

    if (wheelsColorInitials == 'FR') {
      addToCart(caseVariantID);
      return;
    }

    if (wheelsVariantID) {
        const multipleProductIds = [wheelsVariantID, caseVariantID];
        addToCart(multipleProductIds, caseVariantID, 'Changed Wheels Color', wheelsColorName);
    }
}


/***** CUSTOM ANNOUNCEMENT BAR WITH MODAL ******/
document.addEventListener("DOMContentLoaded", function() {
var announcementBar = document.getElementById('announcement-bar');

if (announcementBar) {

  // Get the modal
  var modal = document.getElementById("announcement__modal");

  // Check if the modal and its related elements exist
  if (modal) {
    // Get the button that opens the modal
    var link = document.getElementById("openModal");

    // Get the <span> element that closes the modal
    var closeButton = document.getElementsByClassName("close")[0];

    // When the user clicks the button, open the modal 
    if (link) {
      link.onclick = function() {
        modal.style.display = "block";
      }
    }

    // When the user clicks on <span> (x), close the modal
    if (closeButton) {
      closeButton.onclick = function() {
        modal.style.display = "none";
      }
    }

    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function(event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    }
  }

  // Fix issue with mobile menu when announcement bar is activated
  var menu = document.querySelector('[data-mobile-nav]');
  if (menu) {
    var menuInitialTop = 60; // Initial top value for the mobile menu
    var announcementBarHeight = announcementBar.offsetHeight;

    menu.style.top = menuInitialTop + 'px';

    window.addEventListener('scroll', function() {
      var scrollPosition = window.pageYOffset;

      if (scrollPosition < announcementBarHeight) {
        var topValue = announcementBarHeight - scrollPosition;
        menu.style.top = topValue + 'px';
      } else {
        menu.style.top = '0';
      }
    });
  }
      // Select the element with the class 'site-header--sticky'
    const stickyHeader = document.querySelector('.site-header--sticky');
      // Fix issue with sticky header when announcement bar is activated
      if (stickyHeader) {
        var menuInitialTop = 140; // 
        var announcementBarHeight = announcementBar.offsetHeight;
      
        stickyHeader.style.top = menuInitialTop + 'px';
      
        window.addEventListener('scroll', function() {
          var scrollPosition = window.pageYOffset;
      
          if (scrollPosition < announcementBarHeight) {
            var topValue = announcementBarHeight - scrollPosition;
            stickyHeader.style.top = (topValue + 100) + 'px';
          } else {
            stickyHeader.style.top = '100px';
          }
        });
      }
}
});

/***** CUSTOM RECOMMENDATIONS SECTION ******/

document.addEventListener('variant:change', function (event) {
const targetVariantId = event.detail.variant.id;
const inputElement = document.querySelector(`input[data-variant_id="${targetVariantId}"]`);

if (inputElement) {
  const recommendationValue = inputElement.getAttribute('data-variant-recommendations');

  if (recommendationValue) {
    document.querySelectorAll('div[id$="__product-recommendations"]').forEach((element) => {
      element.style.display = 'none';
    });
    document.querySelectorAll('div[id$="__product-recommendations-manual"]').forEach((element) => {
      element.style.display = 'block';
    });
  } else {
    document.querySelectorAll('div[id$="__product-recommendations-manual"]').forEach((element) => {
      element.style.display = 'none';
    });
    document.querySelectorAll('div[id$="__product-recommendations"]').forEach((element) => {
      element.style.display = 'block';
    });
  }
} else {
  // No input element found with data-variant_id="${targetVariantId}"
}
});

document.addEventListener('DOMContentLoaded', function (event) {
const variantTextarea = document.querySelector('[data-current-variant-json]');

if (variantTextarea) {
  const variantJson = variantTextarea.textContent.trim();

  try {
    const variantData = JSON.parse(variantJson);

    if (variantData && variantData.id) {
      const targetVariantId = variantData.id;
      const inputElement = document.querySelector(`input[data-variant_id="${targetVariantId}"]`);

      if (inputElement) {
        const recommendationValue = inputElement.getAttribute('data-variant-recommendations');

        if (recommendationValue) {
          document.querySelectorAll('div[id$="__product-recommendations"]').forEach((element) => {
            element.style.display = 'none';
          });
          document.querySelectorAll('div[id$="__product-recommendations-manual"]').forEach((element) => {
            element.style.display = 'block';
          });
        } else {
          document.querySelectorAll('div[id$="__product-recommendations-manual"]').forEach((element) => {
            element.style.display = 'none';
          });
          document.querySelectorAll('div[id$="__product-recommendations"]').forEach((element) => {
            element.style.display = 'block';
          });
        }
      } else {
        // No input element found with data-variant_id="${targetVariantId}"
      }
    } 
  } catch (error) {
    // Error parsing JSON data:", error
  }
} 
});

/*** CUSTOM FLY-OUTS IN MENU  ***/

// Existing code for managing flyouts
var links = document.querySelectorAll(".site-nav__link");
var openFlyoutElement = null;

function removeHoverListenersFromFlyoutImageContainers(flyoutElement) {
const imageContainers = flyoutElement.querySelectorAll('.flyout-image-container');

imageContainers.forEach(container => {
  container.removeEventListener('mouseover', () => {});
  container.removeEventListener('mouseout', () => {});
  container.classList.remove('hover-listeners-added');
});
}

function addMouseLeaveListenerToFlyoutContainer(flyoutContainer) {
var flyoutContents = flyoutContainer.querySelectorAll('.flyout-content');

flyoutContents.forEach(function(flyoutContent) {
  flyoutContent.addEventListener("mouseout", function(event) {
      // Check if the mouse is going to the flyout-image-container or its descendants
      if (event.relatedTarget && (event.relatedTarget.classList.contains("flyout-image-container"))) {
        // If moving to flyout-image-container or its children, do nothing
        return;
       }

        if (event.offsetY < 320) {
          return;
        }
      
    if (openFlyoutElement) {
      openFlyoutElement.classList.remove('flyout-block-active');
      openFlyoutElement.style.visibility = "hidden";
      flyoutContainer.style.visibility = "hidden";
      
      removeHoverListenersFromFlyoutImageContainers(openFlyoutElement);
      openFlyoutElement = null;
    } 
  
  });
});
}

function addMouseLeaveListenerToLink(link) {
link.addEventListener("mouseleave", function(event) {
  var flyoutContainer = document.getElementById("fly-out");

  if (event.offsetY > 0) {
    return;
  }

  if (openFlyoutElement && !flyoutContainer.contains(event.relatedTarget)) {
    openFlyoutElement.classList.remove('flyout-block-active');
    openFlyoutElement.style.visibility = "hidden";
    flyoutContainer.style.visibility = "hidden";
    
    removeHoverListenersFromFlyoutImageContainers(openFlyoutElement);
    openFlyoutElement = null;
  }
});
}

function addHoverListenersToFlyoutImageContainers(flyoutElement) {
const imageContainers = flyoutElement.querySelectorAll('.flyout-image-container');

imageContainers.forEach(container => {
  if (!container.classList.contains('hover-listeners-added')) {
    container.addEventListener('mouseover', () => {});
    container.addEventListener('mouseout', () => {});
    container.classList.add('hover-listeners-added');
  }
});
}

links.forEach(function(link) {
link.addEventListener("mouseenter", function() {
  var flyoutId = "flyout-" + this.id;
  var flyoutElement = document.getElementById(flyoutId);
  var flyoutContainer = document.getElementById("fly-out");
  
  if (openFlyoutElement && openFlyoutElement !== flyoutElement) {
    flyoutContainer.style.visibility = "hidden";
    openFlyoutElement.style.visibility = "hidden";
    openFlyoutElement.classList.remove('flyout-block-active');
    removeHoverListenersFromFlyoutImageContainers(openFlyoutElement);
  }

  if (flyoutElement) { 
    flyoutContainer.style.visibility = "visible";
    flyoutElement.classList.add('flyout-block-active');
    flyoutElement.style.visibility = 'visible';
    openFlyoutElement = flyoutElement; 

    // Add hover listeners to the image containers in this flyout
    addHoverListenersToFlyoutImageContainers(flyoutElement);
  }
});

// Add mouseleave listener to each link
addMouseLeaveListenerToLink(link);
});

// Add event listener to close flyout when leaving flyout area
var flyoutContainer = document.getElementById("fly-out");
addMouseLeaveListenerToFlyoutContainer(flyoutContainer);


// Function to add event listeners to flyout image containers
function addHoverListenersToFlyoutImageContainers(flyoutElement) {
const imageContainers = flyoutElement.querySelectorAll('.flyout-image-container');

imageContainers.forEach(container => {
  // Check if the event listeners are already added
  if (!container.classList.contains('hover-listeners-added')) {
    container.addEventListener('mouseover', function() {
      const headingId = 'flyout-heading-' + container.id.split('-')[2];
      const heading = flyoutElement.querySelector('#' + headingId); // Modify to use flyoutElement
      if (heading) {
        heading.classList.add('flyout-heading-hover');
      }
    });

    container.addEventListener('mouseout', function() {
      const headingId = 'flyout-heading-' + container.id.split('-')[2];
      const heading = flyoutElement.querySelector('#' + headingId); // Modify to use flyoutElement
      if (heading) {
        heading.classList.remove('flyout-heading-hover');
      }
    });

    // Mark this container as having event listeners added
    container.classList.add('hover-listeners-added');
  }
});
}

//Add Hover Effect to Logo

document.addEventListener('DOMContentLoaded', function() {
document.getElementById('logo-img').addEventListener('mouseenter', function() {
  this.src = 'https://cdn.shopify.com/s/files/1/0721/0385/4392/files/logo_orange.svg?v=1710424068';
  this.srcset = 'https://cdn.shopify.com/s/files/1/0721/0385/4392/files/logo_orange.svg?v=1710424068 1x, https://cdn.shopify.com/s/files/1/0721/0385/4392/files/logo_orange.svg?v=1710424068 2x';
});
document.getElementById('logo-img').addEventListener('mouseleave', function() {
  this.src = 'https://cdn.shopify.com/s/files/1/0721/0385/4392/files/logo_1.svg?v=1710260708';
  this.srcset = 'https://cdn.shopify.com/s/files/1/0721/0385/4392/files/logo_1.svg?v=1710260708 1x, https://cdn.shopify.com/s/files/1/0721/0385/4392/files/logo_1.svg?v=1710260708 2x';
});
});

/*** Category Teaser Hover auf Startseite ****/
document.addEventListener("DOMContentLoaded", function() {
// Get all category-teaser-image elements
var teaserImages = document.querySelectorAll(".category-teaser-image-container");

// Loop through each teaser image
teaserImages.forEach(function(teaserImage) {
    // Get the parent element of the image
    var parentElement = teaserImage.closest(".category-teaser-item");

    // Get the corresponding category-teaser-heading element
    var teaserHeading = parentElement.querySelector(".category-teaser-heading");

    // Add event listener for mouseenter event
    teaserImage.addEventListener("mouseenter", function() {
        // Add the category-teaser-heading-active class
        teaserHeading.classList.add("category-teaser-heading-active");
    });

    // Add event listener for mouseleave event
    teaserImage.addEventListener("mouseleave", function() {
        // Remove the category-teaser-heading-active class
        teaserHeading.classList.remove("category-teaser-heading-active");
    });
});
});

/*** Hover-Effekt WebM Koffer auf Startseite ***/
document.addEventListener("DOMContentLoaded", function() {
  if (document.body.classList.contains("template-index")) {
    const imageContainers = document.querySelectorAll('.image-wrap');

    imageContainers.forEach(container => {
      container.addEventListener('mouseenter', function() {
        const img = container.querySelector('.grid-product__image');
        
        if (!img) return; // Überspringen, falls kein Bild vorhanden

        // Find the closest anchor tag (a tag)
        const anchorTag = container.closest('a');
        if (!anchorTag) return; // Überspringen, falls kein Link gefunden

        // Get the href attribute of the anchor tag
        const href = anchorTag.getAttribute('href');
        //const excludedProducts = ['/products/floyd-junior', '/products/floyd-bold'];
        const excludedProducts = [];
        
        if (!href || excludedProducts.some(product => href.includes(product))) return; // Effekt überspringen

        // Speichern der ursprünglichen Bildquellen
        const originalSrc = img.getAttribute('src');
        const originalSrcset = img.getAttribute('srcset');

        // Berechnete Stile des Bildes abfragen
        const imgStyles = window.getComputedStyle(img);

        // Video-Element erstellen
        const video = document.createElement('video');
        video.autoplay = true;
        video.loop = true;
        video.muted = true; // Video ohne Ton abspielen
        video.playsInline = true; // Inline-Wiedergabe für mobile Geräte

        // Video-Styling exakt wie das Bild setzen
        video.style.position = imgStyles.position !== 'static' ? imgStyles.position : 'relative'; // Gleiche Position wie das Bild
        video.style.width = imgStyles.width; // Breite des Bildes übernehmen
        video.style.height = imgStyles.height; // Höhe des Bildes übernehmen
        video.style.objectFit = 'cover'; // Sicherstellen, dass das Video den Container ausfüllt
        video.style.objectPosition = 'center'; // Zentrieren des Videos
        video.style.zIndex = imgStyles.zIndex || '1'; // Sicherstellen, dass es sichtbar ist
        video.style.visibility = 'hidden'; // Unsichtbar starten
        video.style.opacity = '0'; // Transparenz verhindern visuelles Blitzen
        video.style.transition = 'opacity 0.2s ease-in-out'; // Sanfter Übergang zur Sichtbarkeit

          // Video-Quelle aus dem data-hoverAnimationUrl Attribut auslesen, falls vorhanden
          const hoverVideoUrl = container.getAttribute('data-hoverAnimationUrl');

          if (hoverVideoUrl && hoverVideoUrl.trim() !== '') {
              // Das Attribut ist vorhanden und nicht leer
              video.src = hoverVideoUrl;
          } else {
              // Fallback auf die bisherige Logik
              if (href.includes('/products/floyd-cabin')) {
                  video.src = 'https://cdn.shopify.com/videos/c/o/v/dca51468b535454484c54b99e8f85370.webm';
              } else if (href.includes('/products/floyd-check-in')) {
                  video.src = 'https://cdn.shopify.com/videos/c/o/v/32f271ecb4d84b5694b3cbcab03103e0.webm';
              } else if (href.includes('/products/floyd-trunk')) {
                  video.src = 'https://cdn.shopify.com/videos/c/o/v/47b93a01f3c640bbaad9b84f77b467d2.webm';
              } else if (href.includes('/products/floyd-junior')) {
                  video.src = 'https://cdn.shopify.com/videos/c/o/v/9e7d1e6e6a9541588e93c2edb960b3f6.webm';
              } else if (href.includes('/products/floyd-bold')) {
                  video.src = 'https://cdn.shopify.com/videos/c/o/v/d1e1068313844b0a96337735bc6ff9ba.webm';
              }
          }

          // Container anpassen
        container.style.position = 'relative';
        container.style.overflow = 'hidden'; // Überstehendes Video abschneiden

        // Video hinzufügen, aber unsichtbar starten
        container.replaceChild(video, img);

        // Video sichtbar machen, nachdem es vollständig geladen ist
        video.addEventListener('loadeddata', function() {
          video.style.visibility = 'visible';
          video.style.opacity = '1'; // Sichtbar machen mit Übergang
        });

        // Rücksetzen bei Mouseleave
        container.addEventListener('mouseleave', function revertToImage() {
          container.replaceChild(img, video); // Video durch ursprüngliches Bild ersetzen
          img.src = originalSrc; // Originale Bildquelle wiederherstellen
          img.srcset = originalSrcset; // Originales Srcset wiederherstellen
          container.removeEventListener('mouseleave', revertToImage); // Listener entfernen
        });
      });
    });
  }
});

/***** PRODUCT GRID TOUCH HANDLING FOR MOBILE *****/
(function() {
  if (!theme.config.bpSmall) return;

  const productGridItems = document.querySelectorAll('.grid-product__content');
  let touchStartY = 0;
  let timeout;

  productGridItems.forEach(item => {
    item.addEventListener('touchstart', (e) => {
      touchStartY = e.touches[0].clientY;
      clearTimeout(timeout);
    });

    item.addEventListener('touchmove', (e) => {
      const touchY = e.touches[0].clientY;
      if (Math.abs(touchY - touchStartY) < 10) { 
        item.classList.add('is-active');
      } else {
        item.classList.remove('is-active');
      }
    });

    item.addEventListener('touchend', () => {
      timeout = setTimeout(() => {
        item.classList.remove('is-active');
      }, 300);
    });
  });
})();
